<template>
  <div>
    <MainHeader />
    <div
      class="timeline-container"
      v-if="state.isempty">
      <div class="lineleft">
        <div>
          <div class="entry-list">
            <div class="nav-tab">
              <div class="tabItem active">文章</div>
            </div>
            <div
              class="infor-list"
              v-for="articleitem in articles"
              :key="articleitem.article_id">
              <div class="flow-header">
                <div class="user">
                  <img
                    :src="articleitem.avatar_url"
                    class="avatar" />
                  <span class="name">{{ articleitem.author }}</span>
                  <div class="date">
                    {{ formatDate(articleitem.created_at) }}
                  </div>
                </div>
              </div>
              <div class="content-wrapper">
                <div>
                  <div class="info">
                    <a
                      :href="`/post/${articleitem.article_id}`"
                      :title="articleitem.title"
                      class="titlelink"
                      target="_blank"
                      ><h1 class="title">{{ articleitem.title }}</h1></a
                    >
                    <a
                      :href="`/post/${articleitem.article_id}`"
                      class="titlelink"
                      target="_blank"
                      ><div class="content">
                        {{ articleitem.brief_content }}
                      </div></a
                    >
                  </div>
                  <!-- <div class="dataview">
                    <span> · 1083 点赞</span>
                    <span> · 46 留言</span>
                  </div> -->
                </div>
                <div
                  class="img"
                  v-if="articleitem.cover_image">
                  <div class="user-image">
                  <a :href="`/post/${articleitem.article_id}`" target="_blank">
                    <img
                      class="image-loct"
                      :src="articleitem.cover_image"
                      width="192"
                      height="128" />
                  </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="hasMore"
              class="load-more"
              @click="loadMore"
              style="text-align: center; padding-top: 50px">
              {{ loading ? "加载中..." : "加载更多" }}
            </div>
            <div v-if="!hasMore">
              <div style="text-align: center; padding-top: 50px">暂无数据</div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="sidebar-container">
          <div class="useritem">
            <img
              :src="userInfo.avatar_url"
              class="avatar" />
            <div
              class="info-box"
              style="visibility: visible">
              <span class="username">
                <span
                  class="name"
                  style="max-width: 128px">
                  {{ userInfo.uname }}
                </span>
              </span>
              <div
                class="position"
                :title="userInfo.job_title + ' @' + userInfo.ucompany">
                {{ userInfo.job_title }} @{{ userInfo.ucompany }}
              </div>
            </div>
          </div>
          <div class="oneself">
            <p>{{ userInfo.description }}</p>
            <div class="aboutme">
              <div v-if="userInfo.blog_address">
                - 个人主页：<a
                  :href="userInfo.blog_address"
                  target="_blank"
                  >{{ userInfo.blog_address }}</a
                >
              </div>
              <div v-if="userInfo.github_html_url">
                - GitHub：<a
                  :href="userInfo.github_html_url"
                  target="_blank"
                  >{{ userInfo.github_html_url }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="empty-list"
      v-if="!state.isempty">
      <div class="null-infor-list">
        <div class="content-flag">
          <div class="common-empty">
            <img src="@/assets/img/404.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, reactive } from "vue";
import type { Ref } from "vue";

import MainHeader from "@/components/main-header.vue";
import { ElMessage } from "element-plus";
import axiosInstance from "@/utils/axiosInstance";
import { format } from "date-fns";
import { useRouter } from "vue-router";

import { useHead } from "@vueuse/head";
import { WebSite_Name } from "@/interface/globalindex";

const SSRData = ref({
  title: "",
  description: "",
  keywords: "",
});

const router = useRouter();

//页面状态
const state = reactive({
  isempty: ref(true),
});

//接口
interface UserInfo {
  uname: string;
  ucompany: string;
  job_title: string;
  avatar_url: string;
  blog_address: string;
  description: string;
  isvip: number;
  userlevel: number;
  phone_verified: number;
  wechat_verified: number;
  weibo_verified: number;
  github_verified: number;
  weibo_nickname: string;
  weibo_html_url: string;
  github_nickname: string;
  github_html_url: string;
  followers: number;
  following: number;
  created_at: string;
}

const userInfo = ref<UserInfo>({
  uname: "",
  ucompany: "",
  job_title: "",
  avatar_url: "",
  blog_address: "",
  description: "",
  isvip: 0,
  userlevel: 0,
  phone_verified: 0,
  wechat_verified: 0,
  weibo_verified: 0,
  github_verified: 0,
  weibo_nickname: "",
  weibo_html_url: "",
  github_nickname: "",
  github_html_url: "",
  followers: 0,
  following: 0,
  created_at: "",
});

//获取用户简介
const fetchUserInfo = async (userId: string) => {
  try {
    await axiosInstance
      .get("/api/HomeUser/profile_id", {
        params: { uuid: userId },
      })
      .then((res) => {
        var result = res.data;
        if (result.success) {
          userInfo.value = result.data;

          //SEO 内容
          SSRData.value.title =
            userInfo.value.uname + " 的个人主页 - 动态 - " + WebSite_Name;
          SSRData.value.description =
            userInfo.value.job_title +
            " @" +
            userInfo.value.ucompany +
            " " +
            userInfo.value.description;
          SSRData.value.keywords = userInfo.value.description;
        } else {
          state.isempty = false;
          //SEO 内容
          SSRData.value.title = "找不到页面";
          SSRData.value.description = "";
          SSRData.value.keywords = "";
        }
        setSSRHead();
      });
  } catch (error) {
    ElMessage.error("获取用户信息失败");
  }
};

//定义数据和接口类型
interface Article {
  article_id: string;
  title: string;
  brief_content: string;
  cover_image: string;
  uuid: string;
}

//时间格式化
const formatDate = (date: string | Date) => {
  return format(new Date(date), "yyyy-MM-dd");
};

const articles = ref<Article[]>([]);
const currentPage = ref(1);
const totalPages: Ref<number> = ref(0);
const loading: Ref<boolean> = ref(false);
const userID = ref("");
const hasMore = ref(true); // 是否还有更多数据

const fetchArticles = async (page: number) => {
  try {
    loading.value = true;
    const response = await axiosInstance.get(
      "/api/HomeArticle/recommend_userinfo_feed",
      {
        params: { page: page, user_id: userID.value },
      }
    );
    var result = response.data;

    if (page === 1) {
      articles.value = result.data.data;
    } else {
      articles.value.push(...result.data.data);
    }
    currentPage.value = result.data.page;
    totalPages.value = result.data.pageCount;
    hasMore.value = currentPage.value <= result.data.pageCount;
  } catch (error) {
    console.error("请求失败:", error);
  } finally {
    loading.value = false;
  }
};

const loadMore = () => {
  if (!hasMore.value || loading.value) return;
  fetchArticles(currentPage.value + 1);
};

onMounted(async () => {
  //获取文章ID 参数
  userID.value = router.currentRoute.value.params.userID as string;
  fetchUserInfo(userID.value);
  fetchArticles(1);
});

//动态设置SEO 信息
const setSSRHead = () => {
  useHead({
    title: SSRData.value.title,
    meta: [
      { name: "description", content: SSRData.value.description },
      { name: "keywords", content: SSRData.value.keywords },
    ],
  });
};
</script>

<style scoped>
/*文章列表 */
.timeline-container {
  display: flex;
  justify-content: space-between;
  max-width: 1020px;
  margin: 20px auto;
}
.lineleft {
  min-width: 720px;
  margin-right: 15px;
  background: #fff;
}

.entry-list {
  padding: 12px 20px;
  border-radius: 8px 8px 0 0;
  cursor: pointer;
}
/*Tab */
.nav-tab {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid #e9e9e9;
}
.nav-tab .tabItem {
  padding: 17px 0;
  font-size: 16px;
  color: #ababae;
  cursor: pointer;
}
.nav-tab .tabItem.active {
  color: #413e3b;
  font-weight: 500;
  border-bottom: 2px solid #b14b43;
}
/*信息流 */
.infor-list {
  font-size: 16px;
  line-height: 26px;
  border-bottom: 1px solid #e5e5e5;
  padding: 10px 0 8px;
}
.flow-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  cursor: pointer;
}
.flow-header .user {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.flow-header .user .avatar {
  width: 20px;
  height: 20px;
  border-radius: unset;
  margin-right: 5px;
}
.flow-header .user span {
  font-size: 14px;
  font-weight: 900;
}
.flow-header .info {
  font-size: 12px;
  color: #ababae;
}
.flow-header .user .name {
  font-weight: 800;
  font-size: 12px;
  line-height: 18px;
}
.flow-header .user .date {
  font-size: 12px;
  line-height: 13px;
  margin-top: 3px;
  margin-left: 5px;
  color: #ababae;
}
.content-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1 1 auto;
  margin-top: 10px;
  position: relative;
}
.info .title {
  cursor: pointer;
  margin: 0 auto;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  font-size: 16px;
}
.info:hover .title {
  color: #cc5656;
}
.titlelink {
  color: #000;
}
.info .content {
  font-size: 14px;
  color: #9d9d9d;
  margin-top: 5px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-height: 26px;
}
.dataview {
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  color: #acabae;
  margin-top: 15px;
}
.empty-box {
  height: 8px;
  display: block;
}
.user-image {
  width: 108px;
  height: 72px;
  border-radius: 6px;
  margin-left: 20px;
  cursor: pointer;
  position: relative;
  display: inline-block;
  overflow: hidden;
}
.image-loct {
  width: 100%;
  height: 100%;
  vertical-align: top;
}
/*
右侧
*/
.sidebar-container {
  background: #fffdfc;
  mix-blend-mode: normal;
  -webkit-backdrop-filter: blur(40px);
  backdrop-filter: blur(40px);
  border-radius: 6px;
  margin-bottom: 20px;
  padding: 18px 19px;
  width: 262px;
  margin-left: 15px;
}
.useritem {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.useritem .avatar {
  width: 64px;
  height: 64px;
  border-radius: 6px;
  -o-object-fit: cover;
  object-fit: cover;
  cursor: pointer;
}
.useritem .stats {
  display: flex;
}
.useritem .info-box {
  flex: 1 1 auto;
  min-width: 0;
  margin-left: 12px;
}
.username .name {
  display: inline-block;
  vertical-align: top;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 900;
}
.useritem .info-box .username {
  font-size: 16px;
  font-weight: 500;
  line-height: 2rem;
  color: #252933;
  white-space: pre-wrap;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.useritem .info-box .username,
.useritem .info-box .username .rank {
  display: flex;
  align-items: center;
}
.useritem .info-box .position {
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #8a919f;
  font-weight: 400;
  line-height: 22px;
}
.oneself {
  color: #acacac;
  font-size: 14px;
  margin-top: 0;
  line-height: 180%;
}
.oneself a {
  color: #cc5656;
  text-decoration: none;
}
/*404 界面 */
.empty-list {
  padding: 12px 20px;
  border-radius: 8px 8px 0 0;
  background: #fff;
  min-width: 800px;
  min-height: 725px;
}
.null-infor-list {
  font-size: 16px;
  line-height: 26px;
  padding: 10px 0 20px;
  margin-top: 51px;
}
.content-flag {
  font-size: 16px;
  font-weight: 400;
  color: #8a919f;
  margin-top: 50px;
}
.common-empty {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}
</style>
